import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../slices/store';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
